import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Employee } from '@app/core/models/employee';
import { select, Store } from '@ngrx/store';
import * as fromStore from './../../../../../store';
import * as fromSelectors from './../../../../../store/selectors';
import { User } from '@app/core/models';
import { Subscription } from 'rxjs';
import { UtilitiesService } from '@app/core/services';
import * as moment from 'moment';
import { EmployeesService } from '@app/core/services/employees.service';

@Component({
    selector: 'app-employee-item-timeline',
    templateUrl: './employee-item-timeline.component.html',
    styleUrls: ['./employee-item-timeline.component.scss']
})
export class EmployeeItemTimelineComponent implements OnInit, OnDestroy {
    @Input() employee: Employee;
    user: User;
    users: User[] = [];
    usersSubscription: Subscription;
    auditData: any[] = [];
    audit = [];
    emailSent = false;

    constructor(
        private store: Store<fromStore.State>,
        private utilities: UtilitiesService,
        private employeeService: EmployeesService
    ) {}

    ngOnInit(): void {
        console.log('[TIMELINE COMPONENT]', this.employee);
        this.store.pipe(select(fromSelectors.getUserEntity)).subscribe((user: User) => {
            this.user = user;
            // this.loadAudit();
        });
        this.usersSubscription = this.store.pipe(select(fromSelectors.getUsersEntities)).subscribe((users: User[]) => {
            this.users = [...users];
            if (this.users && this.users.length) {
                this.loadAudit();
            }
        });
    }

    loadAudit() {
        if (this.employee.audit) {
            this.auditData = this.employee.audit;
            this.audit = this.transformAudit(this.auditData);
        } else {
            this.audit = this.transformAudit([]);
        }
    }

    transformAudit(auditData: any[]) {
        const result = [];

        auditData.forEach((e) => {
            if (e.user_id) {
                const author = this.users.find((u) => u.id === e.user_id);
                if (author) {
                    e.user = author;
                }
            }

            const today = moment()
                .utc()
                .startOf('day')
                .valueOf();
            const timeinmilisec = today - e.created_at * 1000;
            const days = Math.floor(timeinmilisec / (1000 * 60 * 60 * 24));
            days > 14
                ? (e.created_at_rel = moment(e.created_at * 1000).format('DD MMMM YYYY [at] HH:mm'))
                : (e.created_at_rel =
                      this.utilities.fromNow(e.created_at * 1000) + moment(e.created_at * 1000).format('[ at] HH:mm'));
            result.push(e);
        });
        const sorted = result.sort((a: any, b: any) => b.created_at - a.created_at);
        // console.log(sorted);
        return sorted;
    }

    onResendEmail(audit) {
        this.employeeService.resendNotification(this.employee.id, audit.workflow_id, {}).subscribe();
        this.emailSent = true;
        setTimeout(() => {
            this.emailSent = false;
        }, 2000);
    }

    ngOnDestroy() {
        if (this.usersSubscription) {
            this.usersSubscription.unsubscribe();
        }
    }
}
